module.exports = __webpack_public_path__ + "img/17_asia.96a26d23.png";